/** Allowed email domains for signup / admin contact update (same as exchange web register). */
export const ALLOWED_EMAIL_DOMAINS = [
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.in",
  "yahoo.co.uk",
  "ymail.com",
  "rocketmail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
];

export const ALLOWED_EMAIL_PROVIDERS_LABEL =
  "Gmail, Yahoo, Outlook, Hotmail, or iCloud";

export const isValidEmailFormat = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());

export const getEmailDomain = (email) =>
  String(email || "")
    .trim()
    .toLowerCase()
    .split("@")[1] || "";

export const isAllowedEmailDomain = (email) => {
  const domain = getEmailDomain(email);
  return Boolean(domain) && ALLOWED_EMAIL_DOMAINS.includes(domain);
};
